// src/pages/ServicesPage.js
import React from "react";
import { Services } from "../components/services";

export const ServicesPage = () => {
  return (
    <div className="standalone-page">
      <Services />
    </div>
  );
};